import { timerHelperModule } from '../../../../shared/app/helpers/timer-helper';
import { safeUrlFilterModule } from '../../../../shared/app/filters/safe-url-filter';
import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import { appAlertComponentModule } from '../../../../shared/app/components/app-alert/app-alert';
import assessmentSubmittingDialogTemplate from './assessment-submitting-dialog.tpl.html';
import './assessment-submitting-dialog.less';
import { busyIndicatorComponentModule } from '../../../../shared/app/components/busy-indicator/busy-indicator';
import { trackerServiceModule } from '../../../../shared/app/services/tracker-service/tracker-service';

export const assessmentSubmittingDialogComponentModule = angular
  .module('Q.components.assessment-submitting-dialog', [
    timerHelperModule,
    safeUrlFilterModule,
    modalComponentModule,
    appAlertComponentModule,
    busyIndicatorComponentModule,
    trackerServiceModule,
  ])

  .factory(
    'assessmentSubmittingDialog',
    function assessmentSubmittingDialog($modal, $q) {
      let dialog = null;

      function close() {
        if (dialog) {
          dialog.dismiss();
        }
        dialog = null;
      }

      return {
        close,
        open(assessmentResult, timerRanOut = false) {
          close();
          if (
            assessmentResult.isClosed() &&
            !assessmentResult.isSubmitting() &&
            !assessmentResult.hasPostAssessmentActions() &&
            !timerRanOut
          ) {
            // no need to show the dialog if we have nothing to do
            return $q.reject();
          }

          dialog = $modal.openOnce('assessmentSubmittingDialog', {
            template: assessmentSubmittingDialogTemplate,
            controller: 'AssessmentSubmittingDialogCtrl as $ctrl',
            backdrop: 'static',
            windowClass: 'assessment-submitting-dialog',
            keyboard: false,
            resolve: {
              assessmentResult: () => assessmentResult,
              timerRanOut: () => timerRanOut,
            },
          });

          return dialog.result.finally(() => {
            dialog = null;
          });
        },
      };
    },
  )

  .controller(
    'AssessmentSubmittingDialogCtrl',
    function AssessmentSubmittingDialogCtrl(
      $modalInstance,
      $scope,
      AssessmentResult,
      assessmentResult,
      timerRanOut,
      timerHelper,
      appAlert,
      $timeout,
      tracker,
    ) {
      const ctrl = this;
      const { longTimeout, runEvery } = timerHelper;
      // lock in post-submission changes
      ctrl.assessmentResult = AssessmentResult.createInstance(assessmentResult);
      ctrl.timerRanOut = timerRanOut;
      ctrl.inProgress = assessmentResult.isInProgress();
      const assessment = assessmentResult.assessment || {};
      ctrl.noun = {
        assessment: assessment.nounLower || 'assessment',
        Assessment: assessment.nounUpper || 'Assessment',
      };

      const startTime = Date.now();

      const trackData = () => {
        const time = Math.floor((Date.now() - startTime) / 1000);
        return {
          id: assessmentResult.id,
          value: time, // for GA
          time,
          assessmentResultId: assessmentResult.id,
          assessmentId: assessmentResult.assessmentId,
          assessmentTitle: assessment.title,
          teamCandidateId: assessmentResult.teamCandidateId,
          teamId: assessmentResult.teamId,
          team: assessment.team && assessment.team.name,
        };
      };

      const errorTimeout = longTimeout(
        () => {
          if (!assessmentResult.isSubmitted()) {
            tracker.trackError('Assessment Submit Timeout', trackData());
            ctrl.close();
            appAlert.error(
              'There was an error finishing the submission of your assessment, please refresh the page and try again.',
            );
          }
        },
        5 * 60 * 1000,
      ); // wait up to 5 minutes

      let autoRedirectTimer;
      let manualRefreshTimer;
      let completeListener;

      ctrl.complete = () => $modalInstance.close();

      ctrl.close = () => $modalInstance.dismiss();

      function checkSubmitted() {
        ctrl.inProgress = assessmentResult.isInProgress();
        if (assessmentResult.isSubmitted()) {
          if (completeListener) {
            completeListener();
            completeListener = false;
          }
          // lock in post-submission changes
          ctrl.assessmentResult =
            AssessmentResult.createInstance(assessmentResult);
          longTimeout.cancel(errorTimeout);
          tracker.trackEvent('Assessment Submit Completed', trackData());
          runEvery.cancel(manualRefreshTimer);
          if (!assessmentResult.hasPostAssessmentActions()) {
            ctrl.complete();
          } else if (assessmentResult.submissionMessage) {
            ctrl.autoRedirectDelay = -1;
          } else {
            ctrl.autoRedirectDelay = 60;
            autoRedirectTimer = runEvery(() => {
              ctrl.autoRedirectDelay--;
              if (ctrl.autoRedirectDelay < 1) {
                ctrl.complete();
              }
            }, 1000);
          }
        }
      }

      const reloadResult = () => {
        assessmentResult
          .DSRefresh({ ignoreLoadingBar: true })
          .then(checkSubmitted);
      };

      $scope.$on('$destroy', () => {
        longTimeout.cancel(errorTimeout);
        runEvery.cancel(autoRedirectTimer);
        runEvery.cancel(manualRefreshTimer);
        if (completeListener) {
          completeListener();
          completeListener = false;
        }
      });

      if (ctrl.inProgress) {
        completeListener = $scope.$watch(
          () => assessmentResult.state,
          checkSubmitted,
        );

        // Also always manually refresh every 30s in case sockets aren't working correctly
        manualRefreshTimer = runEvery(reloadResult, 30 * 1000);

        checkSubmitted();
      }

      $timeout(() => (ctrl.dialogReady = true));
    },
  );
